import { Component, OnInit } from "@angular/core";

import { Response } from "projects/shared/models/Response";
import { PagingParameters } from "projects/shared/models/PagingParameters";
import { FilterationCriteria } from "projects/shared/models/criteria/FilterationCriteria";

@Component({
  selector: "app-listing",
  template: ""
})
export class GenericListingComponent implements OnInit {
  array = [];
  LatestItem: any;
  public isStory: boolean = false;
  public filter: boolean = false;

  Count: Number;
  TotalCount: Number;

  pageIndex = 0;
  pageSize=8;
  displayShowMoreButton: boolean = true;

  Filteration: FilterationCriteria;
  AppliedFilteration: FilterationCriteria;

  showFilterationCount: boolean = false;

  protected service: any;

  constructor() {}

  ngOnInit() {}

  protected getItems(isScroll: boolean) {
    var param = new PagingParameters<FilterationCriteria>();
    param.pageIndex = this.pageIndex;

    param.pageSize = this.pageSize;
    if (this.AppliedFilteration) {
      param.filterationCriteria = this.AppliedFilteration;
    } else if (param.pageIndex == 0) {
      param.pageSize = this.pageSize;
    }
    this.getPage(param, isScroll);
  }

  protected getPage(param, isScroll) {}

  protected isThereFilter(): boolean {
    return !!this.Filteration;
  }

  protected createFilter() {}

  protected onError(response: any) {}

  protected handleError(response: Response<any>) {}

  protected onSuccess(response: Response<any>, isScroll: boolean = false) {
    if (!(response != undefined && response.isSuccess)) {
      this.handleError(response);
      return;
    }
    this.array = isScroll ? this.array.concat(response.result.items) : response.result.items;
    if (this.shouldTakeLatestItem(response.result)) {
      this.LatestItem = this.array[0];
      this.array.splice(0, 1);
    }

    this.Count = response.result.count;
    this.TotalCount = response.result.totalCount;


    if (
      response.result.count ==
      this.array.length + (this.LatestItem ? 1 : 0)
    ) {
      this.displayShowMoreButton = false;
    }

    if(this.Count==0 && this.TotalCount==0){
      this.showFilterationCount=true;
    }
  }

  protected shouldTakeLatestItem(resp: any): boolean {
    return this.AppliedFilteration == null && resp.pageIndex == 0;
  }

  onScroll() {
    if (this.pageIndex < 2 && this.array.length >= this.pageSize) {
      this.pageIndex++;
      this.getItems(true);
    }
  }

  onShowMore() {
    this.pageIndex++;
    this.getItems(true);
  }

  protected resetListing() {
    this.pageIndex = 0;
    this.array = [];
    this.LatestItem = null;
    this.displayShowMoreButton = true;
  }

  onFilter() {
    if (this.isThereFilter()) {
      this.resetListing();

      this.createFilter();

      this.getItems(false);
    }
  }

  isThereFilterApplied(): boolean {
    return !!this.AppliedFilteration;
  }

  emptyAppliedFilteration() {
    this.AppliedFilteration = null;
    this.Filteration = new FilterationCriteria();
  }

  protected resetFilter(event) {
    event.preventDefault();

    if (this.isThereFilterApplied()) {
      this.emptyAppliedFilteration();

      this.resetListing();
      //Mardy
      this.createFilter();
      this.getItems(false);
    }

    return false;
  }
}
